import React, { useState } from "react";
import { ChevronDown, ChevronRight, Keyboard, X } from "lucide-react";

// Collapsible pre-run stdin input.
// Whatever is typed here is piped to stdin as the first input of the next run.
// This is additive — interactive stdin via the terminal still works after.
export default function StdinBox({ value, onChange, disabled }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="flex-none border-t border-ide-border bg-ide-panel2" data-testid="stdin-box">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-1.5 px-3 py-1.5 text-[11px] uppercase tracking-wider text-ide-mute hover:text-ide-text hover:bg-ide-surface transition-colors"
        data-testid="stdin-toggle-btn"
      >
        {open ? <ChevronDown className="h-3 w-3" /> : <ChevronRight className="h-3 w-3" />}
        <Keyboard className="h-3 w-3" />
        <span>pre-run stdin</span>
        {value && !open && (
          <span className="ml-1 text-[10px] font-mono text-ide-accent">
            · {value.split("\n").length} line{value.split("\n").length > 1 ? "s" : ""}
          </span>
        )}
        {value && (
          <button
            onClick={(e) => { e.stopPropagation(); onChange(""); }}
            className="ml-auto text-ide-mute hover:text-rose-300 p-0.5 rounded hover:bg-ide-panel"
            title="Clear stdin"
            data-testid="stdin-clear-btn"
          >
            <X className="h-3 w-3" />
          </button>
        )}
      </button>

      {open && (
        <div className="px-2 pb-2">
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Type input that will be piped to stdin before the program starts (one value per line)…"
            disabled={disabled}
            spellCheck={false}
            rows={3}
            data-testid="stdin-textarea"
            className="w-full resize-y rounded-md border border-ide-border bg-ide-surface text-ide-text text-[12.5px] font-mono p-2 focus:outline-none focus:border-ide-accent/60 disabled:opacity-50"
            style={{ minHeight: 48, maxHeight: 160 }}
          />
          <div className="text-[10px] text-ide-mute mt-1 font-mono">
            This content is sent first; then the terminal stays interactive for further input.
          </div>
        </div>
      )}
    </div>
  );
}
